<template>
	<RejectedCookiesAlert/>
	<toast-welcom/>
	<router-view/>
	<ModalPrivacy/>
	<InstallPrompt v-if="false"/>
	<CookieNotice/>
</template>

<script>
import ToastWelcom from "@/components/toastWelcom/ToastWelcom";
import InstallPrompt from './components/appInstallPrompt/AppInstallPrompt';
import CookieNotice from "@/components/utils/CookieNotice.vue";
import RejectedCookiesAlert from "@/components/utils/RejectedCookiesAlert.vue";
import ModalPrivacy from '@/components/mods/modalPrivacy/ModalPrivacy.vue'

export default {
	name: 'App',
	components: {
		RejectedCookiesAlert,
		CookieNotice,
		ModalPrivacy,
		ToastWelcom,
		InstallPrompt
	},
}
</script>
